// Shared site-wide constants

export const MERCH_URL =
    "https://www.bonfire.com/store/hearts-of-love-inspirational-apparel/?utm_source=copy_link&utm_medium=store_page_share&utm_campaign=hearts-of-love-inspirational-apparel&utm_content=default";

// Coach Melissa's main coaching site (with Calendly embedded)
export const COACHING_URL = "https://walkwithpurposeco.site";

// Featured merch drops paired with podcast episode themes.
// Add specific URL/title once products land; falls back to MERCH_URL.
export const MERCH_DROPS = {
    "Becoming": {
        title: "The Becoming Tee",
        tagline: "Wear the woman you're becoming.",
    },
    "Break Toxic Cycles": {
        title: "Cycle Breaker Hoodie",
        tagline: "For the daughter who chose differently.",
    },
    "Restore Identity": {
        title: "Daughter of the King Tee",
        tagline: "Crowned, called, and chosen.",
    },
    "Heal Deep Wounds": {
        title: "Soft Healing Hoodie",
        tagline: "Soft on the outside, anointed underneath.",
    },
    "Walk in Purpose": {
        title: "Walk in Purpose Tee",
        tagline: "She rises. So does her assignment.",
    },
};

export const getMerchDrop = (theme) => {
    return (
        MERCH_DROPS[theme] || {
            title: "Hearts of Love Apparel",
            tagline: "Wear the becoming.",
        }
    );
};
